import { SET_IS_ONLINE } from './types';

export const setIsOnline = (isOnline) => ({
    type: SET_IS_ONLINE,
    isOnline,
});
